module.exports = __webpack_public_path__ + "img/letter.374d51ee.jpeg";